import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, resolveDirective as _resolveDirective, openBlock as _openBlock, createElementBlock as _createElementBlock, withDirectives as _withDirectives } from "vue"

const _hoisted_1 = { "txt-center": "" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_el_image = _resolveComponent("el-image")!
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_dialog = _resolveComponent("el-dialog")!
  const _directive_loading = _resolveDirective("loading")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createVNode(_component_el_dialog, {
      "custom-class": "App-User-Profile-Modal",
      "model-value": _ctx.isModalOpen,
      width: "550px",
      "show-close": _ctx.showClose,
      onOpen: _ctx.opened,
      title: "Verify Email",
      center: "",
      "close-on-click-modal": _ctx.showClose,
      "append-to-body": true,
      "lock-scroll": true,
      "open-delay": 200,
      "close-delay": 200,
      "before-close": _ctx.closeModal,
      "close-on-press-escape": false
    }, {
      default: _withCtx(() => [
        _withDirectives((_openBlock(), _createElementBlock("div", null, [
          _createElementVNode("div", null, [
            _createElementVNode("div", null, [
              _createElementVNode("div", _hoisted_1, [
                _createVNode(_component_el_image, {
                  style: `width: 150px;`,
                  src: _ctx.img
                }, null, 8, ["src"]),
                _cache[1] || (_cache[1] = _createElementVNode("h2", {
                  "m-tb-0": "",
                  "f-w-800": "",
                  "txt-center": ""
                }, [
                  _createTextVNode(" Awesome! Now we just need you to confirm ownership of the email"),
                  _createElementVNode("br"),
                  _createTextVNode(" to continue ")
                ], -1)),
                _cache[2] || (_cache[2] = _createElementVNode("p", {
                  "m-rl-auto": "",
                  style: {"max-width":"350px"},
                  "txt-center": ""
                }, [
                  _createTextVNode(" Visit your email inbox for "),
                  _createElementVNode("br"),
                  _createTextVNode(" verification instructions ")
                ], -1)),
                _createVNode(_component_el_button, {
                  onClick: _ctx.resendVerification,
                  type: "primary",
                  plain: "",
                  "is-all-borderless": "",
                  icon: "el-icon-refresh"
                }, {
                  default: _withCtx(() => [...(_cache[0] || (_cache[0] = [
                    _createTextVNode(" Resend Verification ", -1)
                  ]))]),
                  _: 1
                }, 8, ["onClick"])
              ])
            ])
          ])
        ])), [
          [_directive_loading, _ctx.loading]
        ])
      ]),
      _: 1
    }, 8, ["model-value", "show-close", "onOpen", "close-on-click-modal", "before-close"])
  ]))
}